<template>
  <div>
    <TextFormGroup
        :value="value.headline"
        name="headline"
        label="Headline"
        :error="(errors.headline || [])[0]"
        @input="emit('headline', $event)"
    />

    <NumberFormGroup
        :value="value.limit"
        name="limit"
        label="Limit"
        :error="(errors.limit || [])[0]"
        help-text="The number of items to display."
        @input="emit('limit', $event)"
    />

    <NumberFormGroup
        :value="value.days"
        name="days"
        label="Days"
        :error="(errors.days || [])[0]"
        help-text="The number of days to look back when finding the top rendered articles."
        @input="emit('days', $event)"
    />

    <NumberFormGroup
        :value="value.max_age_days"
        name="max_age_days"
        label="Max Age (days)"
        :error="(errors.max_age_days || [])[0]"
        help-text="The maximum age of the articles to include, measured in days (optional)."
        @input="emit('max_age_days', $event)"
    />

  </div>
</template>

<script>
import store from '@/store'
import NumberFormGroup from '@/vendor/forms/FormGroups/Block/Number'
import TextFormGroup from '@/vendor/forms/FormGroups/Block/Text'

export default {
  components: {NumberFormGroup, TextFormGroup},

  props: {
    value: {
      required: true
    },

    errors: {
      required: true
    },

    portal: {
      required: true
    }
  },

  data() {
    return {
      shared: store
    }
  },

  methods: {
    emit(key, value) {
      this.$emit('input', {...this.value, [key]: value})
    }
  }
}
</script>
